import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'checkbox-accessibility',
  templateUrl: './checkbox-accessibility.component.html',
  styleUrls: ['./checkbox-accessibility.component.sass']
})
export class CheckboxAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
